export default "__VITE_ASSET__45e6ef15__"